import { Grid, Typography } from "@mui/material";
import { useResponsive } from "../../../Modulo_Responsive/Hooks/useResponsive";
import Lista_Blogs from "./SubComponentes/Lista_Blogs";

const Soluciones_Servicios = () => {
    const { sCell } = useResponsive();

    return (
        <Grid
            container
            justifyContent="center"
            alignItems="center"
            size={{ xs: 12 }}
            component="section"
        >
            <Grid
                container
                justifyContent="center"
                alignItems="center"
                size={{ xs: 12, sm: 12, md: 10 }}
                sx={{ maxWidth: 1400, px: 3 }}
            >
                {/* Título */}
                <Grid
                    container
                    justifyContent="center"
                    size={{ xs: 12 }}
                    sx={{ pb: 12, borderBottom: '1px solid #DFDFDF' }}
                >
                    <Grid
                        container
                        justifyContent="center"
                        size={{ xs: 12 }}
                        sx={{ mb: 4,  }}
                    >
                        <Typography
                            component="h2"
                            variant="h2"
                            sx={{
                                textAlign: 'center',
                            }}
                        >
                            Soluciones por tipo de espacio
                        </Typography>
                    </Grid>

                    {/* Descripción */}
                    <Grid
                        container
                        justifyContent="center"
                        size={{ xs: 12, sm: 10, md: 10 }}
                        sx={{ pt: 0, maxWidth:'600px' }}
                    >
                        <Typography
                            component="p"
                            variant="body1"
                            sx={{
                                textAlign: 'center',
                            }}
                        >
                            Nuestro enfoque no es estándar ni genérico. Integramos criterio técnico, SST y ejecución especializada según las condiciones reales de cada industria y espacio.
                        </Typography>
                    </Grid>
                    <Grid
                        container
                        justifyContent="center"
                        alignItems="center"
                        size={{ xs: 12, sm: 12, md: 12 }}
                        sx={{ pt: 8 }}
                    >
                        <Lista_Blogs ids={["4", "5", "6"]} />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default Soluciones_Servicios;